import React from 'react';
import { Reportpage } from '../../components/reportpage/reportpage';
import { useLanguage } from '../../i18n';
import {useRovviltskadeRapportNorge} from '../../hooks/featureToggles';
export function ReportRovviltskadeNorge(): React.ReactElement {
    const l = useLanguage();
    const showReportRovviltskadeNorge = useRovviltskadeRapportNorge();

    if (!showReportRovviltskadeNorge) {
        return null;
    }

    return (
        <Reportpage reportKey={'rovviltskadeNorge'} reportName={l('menu.reportRovviltskadeNorge')} reportDescription={l('rovviltskadeNorge.report.description')} />
    );
}